export const NO_RECORDS_FOUND = 'No records found';

export const DEFAULT_PAGE_SIZE = 50;

/** Fixed grid height keeps expand/collapse from resizing the quote page. */
export const AUDIT_TRAIL_GRID_HEIGHT = 520;

/** Max height for multi-event grouped detail panels (scroll inside panel). */
export const AUDIT_TRAIL_DETAIL_PANEL_HEIGHT = 320;

/** Prevents body padding shift when filter dropdowns open (grid column jitter). */
export const AUDIT_TRAIL_SELECT_MENU_PROPS = {
	disableScrollLock: true
};

/** Enter closes the menu after focus moves into the list (e.g. after clicking a checkbox). */
export const AUDIT_TRAIL_FILTER_MENU_PROPS = {
	...AUDIT_TRAIL_SELECT_MENU_PROPS,
	autoFocus: false,
	MenuListProps: {
		autoFocus: false,
		autoFocusItem: false,
		onKeyDownCapture: (event) => {
			if (event.key !== 'Enter') {
				return;
			}

			event.preventDefault();
			event.stopPropagation();
			event.currentTarget.dispatchEvent(
				new KeyboardEvent('keydown', { key: 'Escape', code: 'Escape', bubbles: true, cancelable: true })
			);
		}
	}
};

/** Minimum width for the Event column; column flexes to fill remaining grid space. */
export const AUDIT_TRAIL_EVENT_COLUMN_MIN_WIDTH = 260;

/** Source column width — fits "Automated process" at compact density without truncation. */
export const AUDIT_TRAIL_SOURCE_COLUMN_WIDTH = 160;

/** UI category groups map to persisted event_category values sent to the API. */
export const CATEGORY_FILTER_OPTIONS = [
	{ value: 'Approval', label: 'Approval', categories: ['Approval'] },
	{ value: 'Version', label: 'Version', categories: ['Version'] },
	{ value: 'Quote', label: 'Quote', categories: ['Save'] },
	{ value: 'Item', label: 'Item', categories: ['ItemAdded', 'ItemDeleted', 'GridEdit'] },
	{ value: 'Tab', label: 'Tab', categories: ['TabAdded', 'TabDeleted', 'TabRestored', 'TabUpdated'] },
	{ value: 'CrmSync', label: 'CRM sync', categories: ['CrmSync'] },
	{ value: 'General', label: 'General', categories: ['General'] }
];

export const SOURCE_FILTER_OPTIONS = [
	{ value: 'ConnectWise CPQ', label: 'CPQ' },
	{ value: 'APPSERVER', label: 'Automated process' },
	{ value: 'OrderPorter', label: 'Order Porter' }
];

/** Display labels for persisted event_source values (grid, filter chips). */
export const EVENT_SOURCE_LABELS = Object.fromEntries(
	SOURCE_FILTER_OPTIONS.map((option) => [option.value, option.label])
);

/** Human-readable labels for persisted event_category values. */
export const EVENT_CATEGORY_LABELS = {
	Approval: 'Approval',
	Version: 'Version',
	General: 'General',
	Save: 'Quote update',
	GridEdit: 'Grid edit',
	ItemAdded: 'Item added',
	ItemDeleted: 'Item deleted',
	TabAdded: 'Tab added',
	TabDeleted: 'Tab deleted',
	TabRestored: 'Tab restored',
	TabUpdated: 'Tab updated',
	System: 'System',
	CrmSync: 'CRM sync',
	Publish: 'Publish'
};

/** Event types that can be grouped into meta-rows; Expand filter selects which stay expanded. */
export const EXPAND_FILTER_OPTIONS = [
	{ value: 'Save', label: 'Quote updates', categories: ['Save'] },
	{ value: 'CrmSync', label: 'CRM sync', categories: ['CrmSync'] },
	{ value: 'General', label: 'General', categories: ['General'] },
	{ value: 'GridEdit', label: 'Grid edits', categories: ['GridEdit'] },
	{ value: 'Item', label: 'Item changes', categories: ['ItemAdded', 'ItemDeleted'] },
	{ value: 'Tab', label: 'Tab changes', categories: ['TabAdded', 'TabDeleted', 'TabRestored', 'TabUpdated'] }
];

export const EMPTY_APPLIED_FILTERS = {
	categoryGroups: [],
	sources: [],
	expandGroups: [],
	includeSystem: false
};

/** localStorage key for quote audit trail filter preferences (user-level, all quotes). */
export const AUDIT_TRAIL_FILTER_STORAGE_KEY = 'quoteAuditTrailFilters';

/** Toggle: include rows hidden by default (CRM sync noise, opened-quote, etc.). */
export const SHOW_LOW_PRIORITY_EVENTS_LABEL = 'Show low-priority events';

export const SHOW_LOW_PRIORITY_EVENTS_TOOLTIP =
	'Shows CRM auto-save, quote-opened notices, concurrent-user warnings, and other routine events hidden by default.';
